import getHelper from '../../../services/getHelper';

export default getHelper('/certification-authorities/:id');
